module.exports = __webpack_public_path__ + "static/media/done.8d3bfc3b.jpg";